import React, { useMemo } from "react";
import { Building2, Menu } from "lucide-react";

export default function Header({ collapsed, setCollapsed, setMobileSidebarOpen }) {
    // Lấy thông tin user từ token
    const userName = "Tomotek";

    // Tạo avatar URL từ tên user
    const avatarName = useMemo(() => {
        if (!userName) return "User";
        // Lấy chữ cái đầu của từ cuối cùng trong tên
        const nameParts = userName.trim().split(/\s+/);
        return nameParts[nameParts.length - 1] || "User";
    }, [userName]);

    // Lấy tên ngắn gọn để hiển thị (từ cuối cùng trong tên)
    const displayName = useMemo(() => {
        if (!userName) return "Bạn";
        const nameParts = userName.trim().split(/\s+/);
        return nameParts[nameParts.length - 1] || "Bạn";
    }, [userName]);

    return (
        <header className="flex h-16 items-center justify-between bg-white shadow-sm px-3 py-3 border-b border-gray-200 sm:px-4 lg:h-[80px] lg:px-6 lg:py-4">
            {/* Logo + Toggle */}
            <div className="flex min-w-0 items-center gap-2 sm:gap-4">
                <div className="flex min-w-0 items-center gap-2 sm:gap-3 lg:w-64">
                    <Building2 size={30} className="shrink-0 text-primary sm:size-[35px]" />
                    <h1 className="truncate text-base font-bold tracking-wide text-primary sm:text-xl">
                        WEBCHECK MB
                    </h1>
                </div>

                <button
                    type="button"
                    className="shrink-0 rounded p-2 text-gray-700 transition-colors hover:bg-primary/10 md:hidden"
                    onClick={() => setMobileSidebarOpen(true)}
                >
                    <Menu size={22} />
                </button>
                <button
                    type="button"
                    className="hidden shrink-0 rounded p-2 text-gray-700 transition-colors hover:bg-primary/10 md:inline-flex"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <Menu size={24} />
                </button>
            </div>

            {/* User Info */}
            <div className="flex shrink-0 items-center gap-2 sm:gap-4">
                <span className="hidden font-semibold text-gray-700 sm:inline">
                    Xin chào, {displayName} 👋
                </span>
                <img
                    src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                        avatarName
                    )}&background=7D7ACC&color=fff`}
                    alt="avatar"
                    className="w-10 h-10 rounded-full border-2 border-gray-200"
                />
            </div>
        </header>
    );
}
